declare global {
  interface Window {
    UC_UI?: UC_Utility;
  }
}
interface ServiceInfo {
  consent: {
    history: Array<unknown>;
    status: boolean;
  };
  id: string;
  name: string;
}
interface UC_Utility {
  isInitialized: () => boolean;
  getServicesFullInfo: () => Promise<Array<ServiceInfo>>;
}

const dataDogServiceId = 'Xl0HIOViY';

const waitForUC_UI = (maxRetries = 20, intervalMs = 300): Promise<void> =>
  new Promise((resolve, reject) => {
    let attempts = 0;
    const intervalId = setInterval(() => {
      const isInitialized = Boolean(window.UC_UI?.isInitialized?.());
      if (isInitialized) {
        clearInterval(intervalId);
        resolve();
      } else if (++attempts >= maxRetries) {
        clearInterval(intervalId);
        reject();
      }
    }, intervalMs);
  });

const getServicesFullInfo = async () => {
  try {
    await waitForUC_UI();
    return window.UC_UI?.getServicesFullInfo() ?? [];
  } catch {
    return [];
  }
};

const isDataDogRumConsentAccepted = async () => {
  try {
    const allServices = await getServicesFullInfo();
    const dataDogService = allServices.find((service) => service.id === dataDogServiceId);
    return dataDogService?.consent?.status ?? false;
  } catch {
    return false;
  }
};
export { isDataDogRumConsentAccepted, waitForUC_UI };
